export const environment = {
    production : true,
    version    : '1.0.0',
    baseApi    : 'https://desa-api.campustecnologicodelicai.com',
    campusCode : 'C3',
    cookieDomain: 'desa-web.campusrelacionesinternacionalescomillas.com'
};
